// src/features/streams/components/StreamsViewSwitch.tsx

import { SegmentedControl } from '@mantine/core';
import { useNavigate } from '@tanstack/react-router';
import { useSubAccountStreamsAccess } from '../subaccounts/useSubAccountStreams';

export type StreamsView = 'account' | 'subaccounts';

interface StreamsViewSwitchProps {
  active: StreamsView;
}

/**
 * Master-account toggle between the selected account's streams and the
 * consolidated sub-account monitoring view. Renders nothing when the user
 * has no sub-account access (non-masters, no subcustomerRead, no subs).
 */
export function StreamsViewSwitch({ active }: StreamsViewSwitchProps) {
  const navigate = useNavigate();
  const canView = useSubAccountStreamsAccess();

  if (!canView) return null;

  return (
    <SegmentedControl
      size="xs"
      value={active}
      onChange={(value) => {
        if (value === active) return;
        navigate({ to: value === 'subaccounts' ? '/streams/sub-accounts' : '/streams' });
      }}
      data={[
        { label: 'This Account', value: 'account' },
        { label: 'Sub-Accounts', value: 'subaccounts' },
      ]}
    />
  );
}
